<!--首页模块三-->
<template>
  <div style="font-family: Alibaba">
    <!--采集产品-->
    <div class="boxs_content">
      <div class='index_title'>
        <!--标题-->
        <div>
          <h1>{{ cnNameThree }}</h1>
          <h6>{{ enNameThree }}</h6>
        </div>
        <!--内容-->
        <el-row :span="24" class="box-width carbon background_img">
          <a href="#" class='card_box' @click='handleThreeClick()'>
            <el-col :md="12" :sm="12" :xs="24">
              <div class="div_img">
                <el-image
                  style="width: 100%"
                  :fit='fit'
                  v-if='homeThreeVo.fullPathUrl != null'
                  :src='homeThreeVo.fullPathUrl'
                />
              </div>
            </el-col>
            <el-col :md="12" :sm="12" :xs="24">
              <div class="text">
                <h5>{{ homeThreeVo.title }}</h5>
                <div v-html="homeThreeVo.briefIntroduction" class="htmlImgSize" style="color: #606266"></div>
              </div>
            </el-col>
          </a>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import { findEnNameOne, findHomeThree } from '@/api/zh'

export default {
  created () {
  },
  data () {
    return {
      enNameThree: '',
      cnNameThree: '',
      homeThreeVo: {},
      fit: 'fill',
      url: require('@assets/images/index/chanping.png'),
      url1: require('@assets/images/index/chanping1.png'),
      url2: require('@assets/images/index/chanping2.png'),
      gatherUrl: require('@assets/images/index/caiji.png')
    }
  },
  mounted () {
    this.selectThree()
  },
  methods: {
    /** 查询英文名称 */
    selectEnName (cnEnNameId) {
      let that = this
      findEnNameOne(cnEnNameId).then(res => {
        let data = res.data
        that.enNameThree = data.enName
        that.cnNameThree = data.cnName
      })
    },
    async selectThree () {
      let that = this
      await findHomeThree().then(res => {
        if (res.data.cnEnNameId !== null) {
          that.selectEnName(res.data.cnEnNameId)
        }
        that.homeThreeVo = res.data
      })
    },
    handleThreeClick () {
      const routeData = this.$router.resolve({
        path: this.homeThreeVo.linksVo.href,
        query: { tabId: this.homeThreeVo.linksVo.id }
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>
<style scoped>
</style>
